module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.woff?925b340f49e65e8bab10da01bbcf9e30";